module.exports = __webpack_public_path__ + "4ad33766de1ff89cc7adda4470ddcdda.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/dracula-cape.png
// module id = 1831
// module chunks = 0